module.exports = __webpack_public_path__ + "static/media/whatsapp_guide_desktop_03.5e319911.svg";